/**
 * Anonymous cart identity. Guests don't have an auth token, so their server-side
 * cart is identified by a client-generated token sent as the `X-Cart-Token` header.
 * The token is persisted in localStorage so the cart survives refreshes.
 */
const CART_TOKEN_KEY = 'cartToken';

/** Get the existing guest cart token, creating one if it doesn't exist yet. */
export function getCartToken(): string {
  let token = localStorage.getItem(CART_TOKEN_KEY);
  if (!token) {
    token =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(CART_TOKEN_KEY, token);
  }
  return token;
}

/** Read the guest cart token without creating one. */
export function peekCartToken(): string | null {
  return localStorage.getItem(CART_TOKEN_KEY);
}

/** Remove the guest cart token (e.g. after merging into a user cart on login). */
export function clearCartToken(): void {
  localStorage.removeItem(CART_TOKEN_KEY);
}
